import * as go from 'gojs';
import { store } from 'createStore';
import { editConnection } from '../../store/connections/sagaActions';

const hasConnectionChanged = (
  fromPort: string | undefined,
  toPort: string | undefined,
  to: string | undefined,
  from: string | undefined,
  flowRatePosition: unknown,
) => {
  const connections =
    store.getState().unitConnGroup.present.connectionState.connections;
  const connection = connections.find(
    (connection) =>
      connection.fromPort === fromPort || connection.toPort === toPort,
  );

  return (
    !connection ||
    connection.fromPort !== fromPort ||
    connection.toPort !== toPort ||
    connection.to !== to ||
    connection.from !== from ||
    connection.flowRatePosition !== flowRatePosition
  );
};

export const connectionHandler = (e: go.ChangedEvent) => {
  switch (e.change) {
    case go.ChangedEvent.Property:
      if (
        e.modelChange === 'linkToPortId' ||
        e.modelChange === 'linkFromPortId'
      ) {
        const fromPort = e.object?.fromPort;
        const toPort = e.object?.toPort;
        const to = e.object?.to;
        const from = e.object?.from;
        const flowRatePosition = e.object?.flowRatePosition;

        if (
          !hasConnectionChanged(fromPort, toPort, to, from, flowRatePosition)
        ) {
          return;
        }

        const editConnectionData = {
          portMode: e.modelChange,
          fromPort: fromPort,
          toPort: toPort,
          to: to,
          from: from,
          flowRatePosition: flowRatePosition,
        };
        store.dispatch(editConnection([editConnectionData]));
      }
      break;
    default:
      break;
  }
};
